// extracted by mini-css-extract-plugin
export default {"heading":"Kj-z","list":"Lj-z"};